import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CharacterImageVariant, ImageContainerShape, renderCharacterImage, } from '@datapad/common-controls';
import { ListItemAvatar, ListItemButton, ListItemText, Typography } from '@mui/material';
export function ContactListItem(props) {
    const { contact, isSelected, onClick } = props;
    const nameToDisplay = contact.shortName ?? contact.name;
    const titleToDisplay = contact.titles.length === 0 ? undefined : contact.titles[0];
    return (_jsxs(ListItemButton, { selected: isSelected, onClick: onClick, sx: { borderRadius: 1 }, children: [_jsx(ListItemAvatar, { children: renderCharacterImage(contact, {
                    maxWidthInPixels: 40,
                    maxHeightInPixels: 40,
                    containerShape: ImageContainerShape.Circle,
                    variant: CharacterImageVariant.Profile,
                }) }), _jsx(ListItemText, { primary: _jsx(Typography, { variant: "body1", color: "text.secondary", noWrap: true, children: nameToDisplay }), secondary: titleToDisplay && (_jsx(Typography, { variant: "body2", color: "text.secondary", noWrap: true, children: titleToDisplay })) })] }));
}
//# sourceMappingURL=ContactListItem.js.map